import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { VehicleBookingService } from './vehicle-booking.service';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';  
@Component({
  selector: 'app-vehicle-booking',
  templateUrl: './vehicle-booking.component.html',
  styleUrls: ['./vehicle-booking.component.sass']
})
export class VehicleBookingComponent implements OnInit {
  page: number = 1;
  itemsPerPage = 5;
  totalItems : any;

  searchText:any;
  allVehicleBookingList:any;
  allVehicleBookingList_forFilter:any;
  closeResult:string;
  constructor( private spinner:NgxSpinnerService,
    private toastr:ToastrService,
    private modalService: NgbModal,
    private router : Router,
    private vehicleBookingService : VehicleBookingService) { }

  ngOnInit(): void {
    this.getAllVehicle()
  }
  
  getAllVehicle(){
      this.spinner.show()
    let data = {
      "perPage": 5,
      "page": 0,
      "isDeleted": 0
    }
    this.vehicleBookingService.getAllBookingVehicles(data).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.allVehicleBookingList = result.data
        this.allVehicleBookingList_forFilter = result.data;
        this.totalItems = result.totalRecords;
        console.log(result)
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }

  gty(page: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :this.page-1,
       "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    }
    this.vehicleBookingService.getAllBookingVehicles(data).subscribe((result:any)=>{
      if(result.statusCode  == 200){
        this.allVehicleBookingList = result.data
        this.allVehicleBookingList_forFilter = result.data;
        this.totalItems = result.totalRecords;
        this.spinner.hide()
      }else{
        this.allVehicleBookingList = result.data
        this.allVehicleBookingList_forFilter = result.data;
        this.totalItems = result.totalRecords;
        this.spinner.hide();
        this.toastr.error(result.message)
      }
    })
  }

  id:any;
  vehicleID:any;
  packageID:any;
  bookingStatus:any;
  status:any;
  editVehicleBooking(data , editBooking){
      this.openModal(editBooking);
      this.id = data._id;
      this.vehicleID = data.vehicleId;
      this.packageID = data.packageId;
      this.bookingStatus = data.bookingStatus;
      this.status = data.status;
  }

  updateVehcleBooking(){
    let data = {
      "id" : this.id,
      "bookingStatus" : this.bookingStatus,
      "status" : this.status
    }
    this.spinner.show()
    this.vehicleBookingService.updateVehicleBooking(data).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.toastr.success(result.message)
        this.getAllVehicle()
        this.modalService.dismissAll()
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }

  applyFilter(filterValue:any){
    console.log(filterValue);
    let filterValueLower = filterValue.toLowerCase();
         if(filterValue === '' ) {
             this.allVehicleBookingList =this.allVehicleBookingList_forFilter;
         } 
         else {
          this.allVehicleBookingList = this.allVehicleBookingList_forFilter.filter((employee:any) => employee.vehicleId.toLowerCase().includes(filterValueLower))
         }
  }


  deleteVehicleBooking(data:any){
    let sendKey = {
      "id" : data._id,
      "isDeleted" : 1
    }
    this.spinner.show()
    this.vehicleBookingService.updateVehicleBooking(sendKey).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          this.toastr.success("Booking Deleted Successfully")
          this.getAllVehicle()
        }else{
          this.spinner.hide()
          this.toastr.error(result.message)
        }
    })
  }

  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "Vehicle Bookings.xlsx");
   }

   openModal(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
